import React from 'react';
import ReactDOM from 'react-dom';
import { C } from './styles/theme';

const S = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,20,64,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999, backdropFilter: 'blur(4px)', animation: 'fadeIn 0.2s ease' },
  modal: { background: C.white, borderRadius: 16, width: '92%', maxWidth: 540, maxHeight: '88vh', display: 'flex', flexDirection: 'column', boxShadow: '0 24px 64px rgba(0,32,91,0.2)', animation: 'scaleIn 0.25s ease', overflow: 'hidden' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 24px', borderBottom: `1px solid ${C.g100}`, flexShrink: 0 },
  body: { padding: 24, overflowY: 'auto', flex: 1 },
  closeBtn: { background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: C.g400, width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' },
};

export default function Modal({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;
  
  const modalContent = (
    <div style={S.overlay} onClick={onClose}>
      <div style={S.modal} onClick={e => e.stopPropagation()}>
        <div style={S.header}>
          <h3 style={{ margin: 0, fontFamily: "'Outfit', sans-serif", fontSize: 18, color: C.navy }}>{title}</h3>
          <button onClick={onClose} style={S.closeBtn}>✕</button>
        </div>
        <div style={S.body}>{children}</div>
      </div>
    </div>
  );
  
  // If there's a fullscreen element, render inside it; otherwise render to body
  const portalTarget = document.fullscreenElement || document.webkitFullscreenElement || document.body;
  
  return ReactDOM.createPortal(modalContent, portalTarget);
}
